// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\studios.$type.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\studios.$type.tsx");
  import.meta.hot.lastModified = "1760465839278.2031";
}
// REMIX HMR END

import { useLoaderData } from "@remix-run/react";
import { WelcomeSection, StudiosSection, PhotoSection, BookSection } from "~/components/pages/studios";
import { MembershipSection } from "~/components/shared/MembershipSection";
import { PeopleSection } from "~/components/shared/PeopleSection";
//import { studiosConfig, type StudioType } from "~/config/studios";
import en from "~/config/lang/en.json";
import sp from "~/config/lang/sp.json";
const translations = {
  en,
  sp
};
export async function loader({
  params
}) {
  const type = params.type;

  // get language from location storage
  const lang = "en"; //localStorage.getItem("lang") || "en";

  // get translations based on language
  const languageData = translations[lang];
  const studioData = languageData[type];
  if (!studioData) {
    throw new Response("Studio Not Found", {
      status: 404
    });
  }
  const apiRes = await fetch(`https://nomadicstudios.net:444/api/studios?type=${type}`);
  const apiData = await apiRes.json();
  console.log(apiData);
  return Response.json({
    type,
    studioData,
    apiData
  });
}
export const meta = ({
  data
}) => {
  if (!data) {
    return [{
      title: "Studio Not Found | Nomadics"
    }, {
      name: "description",
      content: "The requested studio type was not found."
    }];
  }
  return [{
    title: data.studioData.meta.title
  }, {
    name: "description",
    content: data.studioData.meta.description
  }];
};
export default function StudioPage() {
  _s();
  const {
    studioData,
    apiData
  } = useLoaderData();
  return <div>
      <WelcomeSection data={studioData.welcome} />
      <StudiosSection data={studioData.studios} />
      <PhotoSection data={studioData.gallery} />
      <BookSection title={studioData.book.title} description={studioData.book.description} data={apiData} />
      <PeopleSection title="OUR CREW" />
      <MembershipSection theme="black" />
    </div>;
}
_s(StudioPage, "3meHLk4mOxD7EGaXGcF+abp6+xE=", false, function () {
  return [useLoaderData];
});
_c = StudioPage;
var _c;
$RefreshReg$(_c, "StudioPage");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;